import LogRow from "./LogRow";
import Pagination from "./Pagination";
import "../monitor.css";

const LogTable = ({ logs, onViewDetails, pageTrack, pagination, onPageChange, onLimitChange }) => {
  return (
    <div
      className="monitor_container"
      style={{ height: "100%", display: "flex", flexDirection: "column", width: "100%" }}
    >
      <div className="table-wrapper">
        <table className="log-table">
          <thead>
            <tr>
              <th>App Name</th>
              <th>Success</th>
              <th>Type</th>
              <th>Details</th>
              <th>Duration</th>
              <th>User Email</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {logs.map((log, index) => (
              <LogRow key={log?.id || index} log={log} onViewDetails={onViewDetails} />
            ))}
          </tbody>
        </table>
      </div>

      <div className="pt_4">
        <Pagination
          pageTrack={pageTrack}
          pagination={pagination}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
        />
      </div>
    </div>
  );
};

export default LogTable;
